<div class="container">
  <div class="container-card">
    <mat-card appearance="outlined" class="mat-component-background mat-elevation-z2">
      <mat-card-content>
        <p><strong>This page is the updated Terms and Conditions; for the version effective until August 4th, 2025, click <a
            href="/partner-terms-31-july-2024">here</a>.</strong></p>
      </mat-card-content>
    </mat-card>
  </div>

  <h1>Partner Terms</h1>

  <div class="container-last-updated">
        <em>Effective Date: August 4th, 2025 Last updated: July 1st, 2025</em>
    </div>

  <h2>Welcome to Planet VG!</h2>
  <p>
    Planet VG is the eco- and animal-friendliest way to reward your customers for their loyalty.
  </p>
  <p>
    Before joining our mission and connecting with conscious consumers, it’s important to take a moment to review these
    Partner Terms. By utilizing our loyalty reward program services (<strong>“Services”</strong>), you’re confirming
    that you’ve read,
    understood, and agreed to these Partner Terms. This ensures we’re all on the same page as we work together to make a
    difference for animals and the planet.
  </p>
  <p>
    If you don’t agree to these Terms, you won’t be able to access our Services. Got questions or need clarity? Feel
    free to reach out to us!
  </p>

  <h2>1. About us</h2>
  <p>
    <strong>1.</strong> Planet VG (<strong>“we”, “our”</strong>) is a trade name owned by Almost Level 5 B.V., a company
    with private limited liability
    under Dutch law, having its registered office at Oder 20 Unit E2574, 2491DC The Hague (the Netherlands).
  </p>
  <p>
    <strong>2.</strong> If you have any questions, remarks or just want to share something, you can contact us in the
    following ways:
    <br />
    <br />
    By email: support&#64;planet.vg
    <br />
    By post: Almost Level 5 B.V., Oder 20 Unit E2574, 2491DC The Hague (the Netherlands)
    <br />
    <br />
    And some important numbers:<br />
    Chamber of Commerce: 93949138<br />
    Dutch VAT-number: NL866583920B01
  </p>

  <h2>2. Our services and mission</h2>
  <p>
    <strong>1.</strong> Planet VG is a platform designed to connect climate-conscious and vegan individuals with
    businesses (<strong>“Partners”, “you”</strong>) committed to creating a better world. Our mission is to foster a
    closer relationship
    between these communities while promoting sustainable and animal-friendly choices. Through our <strong>Customer
      App</strong>, users
    can discover vouchers, collect loyalty stamps, and earn rewards by supporting local, sustainable, and vegan
    businesses like yours. As a Partner, Planet VG offers you the tools to create a loyalty reward program tailored for
    registered members (<strong>“Customers”</strong>) using the Customer App. This enables you to engage with a growing
    community of
    individuals who value sustainability, veganism, and conscious living.
  </p>
  <p><strong>2.</strong> Planet VG is specifically designed to provide loyalty reward program services. It is not a
    social media or social networking platform. There is no direct communication between Customers and Partners who
    maintain an account on Planet VG. The platform focuses solely on facilitating rewards, stamps, and vouchers.
  </p>

  <h2>3. Getting started as a Partner</h2>
  <p>
    <strong>1.</strong> Before you can start offering loyalty rewards to your Customers through our Services, you’ll
    need to create an account. This can be done via our partner website or the Customer app. Once your account is
    created, you’re ready to join our mission! You can then purchase a subscription through the partner website.
    Following a successful purchase, we will create a partner account for you.
  </p>

  <p>
    <strong>2.</strong> We reserve the right to decline any application for a partner account. For example, if we
    believe that your business or products do not align with our core values, we may choose not to approve your
    application and won’t issue a partner account.
  </p>

  <p><strong>3.</strong> As a Partner, you’ll gain access to tools for rewarding your Customers via our Services. You
    are entirely responsible for managing your account, including securing your username and password.
  </p>

  <h2>4. Making a difference with your loyalty reward program</h2>
  <p>
    <strong>1.</strong> As a Partner, you have the opportunity to make a meaningful impact by offering animal-friendly
    loyalty rewards. You are solely responsible for designing and defining the rules of your loyalty program including
    offers and rewards tailored to your Customers. These rewards must align with vegan principles and promote veganism.
    Your offers will be displayed to Customers through our Customer App, our website, and on www.planet.vg/discover.
  </p>
  <p>
    <strong>2.</strong> Customers can earn rewards through our Customer App based on predefined criteria, such as
    purchase value, visit frequency, or specific actions. Once the required conditions are met, the Customer will
    receive the reward you’ve set. It’s your responsibility to ensure that the reward system is clearly communicated to
    customers and implemented smoothly.
  </p>

  <h2>5. Maintaining integrity</h2>
  <p>
    <strong>1.</strong> To preserve the integrity of Planet VG, all loyalty reward programs must align with our core
    mission of promoting veganism. This means all rewards and associated content must be animal-friendly and consistent
    with vegan values. We conduct random checks and reserve the right to review your program whenever we identify a
    reason to investigate. If we determine that your program does not meet our standards, we may take appropriate
    action, including suspension of your account. We will notify you accordingly.
  </p>

  <h2>6. Handling Customer feedback and complaints</h2>
  <p>
    <strong>1.</strong> As a Planet VG Partner, you can choose between a monthly or annual subscription. Your chosen
    subscription type will determine your billing and notice period for cancellation. A subscription runs for a minimum
    period. Your subscription will automatically renew at the end of the period, according to the frequency of your
    subscription, unless you choose to cancel your subscription before the end of the then-current subscription period.
    So, for example, if you’ve paid for an annual subscription, your subscription will renew automatically on each
    anniversary of the date you signed up to use our Services, unless you make sure that you cancel your subscription on
    time.
  </p>
  <p>
    <strong>2.</strong> We may update subscription fees annually. If changes occur, we’ll notify you at least one month
    in advance via email. The updated fees will take effect from the start of your next billing cycle.
  </p>

  <p>
    <strong>3.</strong> You can cancel your subscription at any time, respecting the notice period that corresponds to
    your subscription type (monthly or annual). To finalize your cancellation:
  </p>
  <ul>
    <li>All unpaid invoices must be cleared.</li>
    <li>Your subscription will terminate at the end of the current billing period following the notice period.</li>
  </ul>

  <p>
    <strong>4.</strong> We reserve the right to cancel or suspend your subscription unilaterally, and without having to
    pay any compensation in the event of such termination or suspension, in cases such as:
  </p>
  <ul>
    <li>Non-payment of subscription fees.</li>
    <li>Fraudulent activity, including legal non-compliance, involving your account or business.</li>
    <li>Providing false or misleading information during the registration or ongoing use of our Services.</li>
    <li>The Partner breaching any of the terms and conditions of these Partner Terms.</li>
  </ul>
  <p>
    <strong>5.</strong> Planet VG does not offer free subscription plans. All subscriptions come with associated fees.
  </p>
  <p>
    <strong>6.</strong> All payments are non-refundable, even if the Services are not used or the subscription is
    canceled before the end of the billing period.
  </p>
  <p>
    <strong>7.</strong> Fees are in Euros.
  </p>
  <p>
    <strong>8.</strong> If a limited trial or promotion is offered, regular subscription fees will automatically apply
    once the trial or promotion period ends.
  </p>
  <p>
    <strong>9.</strong> Our prices do not include Value Added Tax (VAT).
  </p>
  <p>
    <strong>10.</strong> When terminating the service we provide, we shall supply a justification to the relevant
    Partner at least 30 days before the termination takes effect.
  </p>

  <h2>8. Partner's obligations</h2>
  <p>
    As a Partner, you agree to the following obligations and ensure that all actions, materials, and communications meet
    the standards outlined below:
  </p>
  <p>A) You guarantee that all promotional content, loyalty reward programs, and communications through Planet VG comply
    with relevant advertising laws, regulations, and codes, ensuring that content is truthful, legal, and not
    misleading.</p>
  <p>B) You confirm that all information provided to Planet VG is accurate, complete, and up-to-date.</p>
  <p>C) You ensure that all content and offers shared through Planet VG:</p>
  <ul>
    <li>Align with ethical and vegan principles (non-vegan products, services, or practices are prohibited).</li>
    <li>Do not contain offensive, obscene, or defamatory material.</li>
    <li>Avoid discriminatory, threatening, or harmful language.</li>
    <li>Respect the rights of others, including intellectual property rights.</li>
    <li>Comply with all relevant laws and regulations.</li>
  </ul>
  <p>D) Rewards, vouchers, and loyalty stamps must be genuine and offered in good faith. Manipulating reward programs,
    including misrepresenting offers, is not allowed. </p>
  <p>Additionally, avoid language or imagery that could harm the reputation of Planet VG or alienate Customers and other
    Partners.</p>
  <p>E) You guarantee that all files and content uploaded to Planet VG are free from viruses, malware, or harmful code
    that could disrupt the Services or affect other Partners or Customers.</p>
  <p>F) You are responsible for providing all content for your loyalty reward programs, including images, descriptions,
    logos, and other content. </p>

  <h2>9. Intellectual property</h2>
  <p>
    <strong>1.</strong> All rights to Planet VG’s intellectual property—including copyrights, trademarks, patents, and
    trade secrets—belong exclusively to Planet VG and its licensors. This includes everything in the Customer App, the
    Partner App, and all content, designs, or materials on those apps.
  </p>
  <p>
    <strong>2.</strong> When the Partner uploads or shares content—such as photos of vegan meals, logos, designs, or
    other materials—they grant Planet VG a non-exclusive, worldwide, royalty-free, sublicensable, and transferable
    license to use, copy, modify, distribute, publicly display, and reproduce that content. This allows us to provide
    our Services and promote your business.
  </p>
  <p>
    <strong>3.</strong> The Partner guarantees they have the right to share this content and grant this license, and
    that the content does not infringe on any third-party rights. In short, make sure your content is as clean and
    ethical as a plant-based feast.
  </p>
  <p>
    <strong>4.</strong> By becoming a Partner, you also grant us a royalty-free, non-exclusive license to use your
    (company) name and logo in our marketing materials, including but not limited to flyers, websites, marketing emails,
    and other promotional content.
  </p>

  <h2>10. Fair use policy</h2>
  <p>
    <strong>1.</strong> We reserve the right to implement a Fair Use Policy. This means that we are entitled to monitor
    the use of Planet VG and limit or suspend access if we believe that our Services are being used excessively.
    Excessive use includes, but is not limited to, large amounts of data storage and extensive use of bandwidth.
  </p>

  <h2>11. “As is” and “as available”</h2>
  <p>
    <strong>1.</strong> While we work hard to provide a reliable service, we can't guarantee that everything will
    always run smoothly or that our applications and websites will be free of errors or delays. This means, for example:
  </p>
  <ul>
    <li>Sometimes, Planet VG may be unavailable due to maintenance, updates, or other reasons. We’re not liable for any
      issues caused by Planet VG being unavailable.</li>
    <li>That we do not promise Planet VG will meet your expectations.</li>
    <li>While we aim to keep everything safe, we can't guarantee that Planet VG is completely free from viruses or other
      harmful software.</li>
  </ul>
  <p>
    <strong>2.</strong> Planet VG is constantly improving. We may modify, update, or change Planet VG at any time,
    including adding new features, removing outdated ones, or suspending certain aspects temporarily or permanently.
    Occasionally, automatic updates will be installed to improve features, fix bugs, or enhance performance. These
    updates may occur without additional notice or explicit consent. By using Planet VG, you agree to these automatic
    updates. We may also notify you about updates via email. While we value your feedback, the final decision on changes
    or updates remains with us.
  </p>
  <p>
    <strong>3.</strong> We are not obligated to retain any data or materials that we receive or have developed, nor are
    we required to return such data or materials following the termination of your subscription.
  </p>

  <h2>12. Limitation of liability</h2>
  <p>
    <strong>1.</strong> Planet VG provides a platform to empower your vegan business, but its use is ultimately at your
    own risk. By using our Services, you acknowledge and agree to the following:
  </p>
  <ul>
    <li>Planet VG is not liable for any indirect, incidental, consequential, or punitive damages, including but not
      limited to lost profits, lost revenue, or loss of data, arising from your use of the Partner App or Services.</li>
    <li>In the event of proven negligence on our part, our liability is strictly limited to no more than 50% of the
      subscription fees paid by you in the 12 months preceding the incident. This limitation does not apply if the
      damage is caused by intent or gross negligence on the part of Planet VG.</li>
    <li>While we strive for seamless service, disruptions or technical issues may occur. Planet VG is not liable for
      damages caused by such interruptions, and Partners remain responsible for all payments due during any downtime or
      service issues.</li>
    <li>Planet VG is not liable for any damages or losses caused by third-party actions, including customer disputes,
      complaints, or (legal) issues related to your loyalty
      reward program.</li>
    <li>
      Any claim or demand against Planet VG must be filed within 12 months from the termination of your subscription.
    </li>
  </ul>

  <h2>13. Force majeure</h2>
  <p>
    <strong>1.</strong> Planet VG is dedicated to providing seamless services, but sometimes life throws unexpected
    challenges our way. We are not liable for any delays or failures in performance caused by circumstances beyond our
    reasonable control, including but not limited to:
  </p>
  <ul>
    <li>Natural disasters, such as floods, earthquakes, or extreme weather conditions.</li>
    <li>Government actions, regulations, or restrictions.</li>
    <li>Wars, riots, or other acts of civil unrest.</li>
    <li>Power outages, internet disruptions, or technological failures.</li>
    <li>Pandemics, epidemics, or other public health emergencies.</li>
  </ul>

  <p>
    <strong>2.</strong> If a force majeure event occurs, we’ll do our best to minimize the disruption and keep you
    informed. However, during such events, our obligations under these Partner Terms may be delayed or suspended until
    the situation is resolved.
  </p>
  <p>
    <strong>3.</strong> If a force majeure event continues for a period of 2 months or more, you will have the right to
    terminate the agreement (in whole or in part) by sending an email to support&#64;planet.vg.
  </p>

  <h2>14. Warranties</h2>
  <p>
    <strong>1.</strong> Planet VG makes no guarantees, beyond what’s clearly stated in writing. All implied warranties,
    conditions, and representations are excluded unless required by applicable law.
  </p>
  <p>
    <strong>2.</strong> We can’t promise that the Services are completely free of bugs, viruses, or interruptions. While
    we work hard to make it seamless, perfection isn’t guaranteed.
  </p>
  <p>
    <strong>3.</strong> We don’t guarantee that your loyalty reward program will attract or engage customers. Success
    depends on how you craft and manage your offers.
  </p>
  <p>
    <strong>4.</strong> You warrant that all content you upload complies with relevant laws and regulations. It’s your
    responsibility to ensure your materials are legal and appropriate for all regions where your loyalty reward program
    is accessible.
  </p>

  <h2>15. Indemnity</h2>
  <p>
    <strong>1.</strong> By using our Services, you agree to indemnify, defend, and hold harmless Planet VG, our
    affiliates, officers, employees, and agents from any claims, liabilities, damages, losses, costs, or expenses
    (including legal fees) that arise from:
  </p>
  <ol>
    <li>Your use of the Services or Partner App, including your loyalty reward program’s creation, management, or
      execution;</li>
    <li>Any content you upload or share, such as claims of infringement, misrepresentation, or legal violations;</li>
    <li>Disputes or complaints from your Customers related to your loyalty reward program, or business practices;</li>
    <li>Breach of these Partner Terms or any applicable laws and regulations by you.</li>
  </ol>

  <p>
    <strong>2.</strong> If we get dragged into a dispute because of something tied to your partner account, we reserve
    the right to take over the defense (at your expense). You’ll also need to cooperate fully to help resolve the
    matter.
  </p>

  <h2>16. Complaints</h2>
  <p>
    <strong>1.</strong> If you have any complaints or issues regarding your use of the Services or Partner App, please
    email us at support&#64;planet.vg. We’ll make sure to respond to your concerns within five days.
  </p>

  <h2>17. Changes to these Partner Terms</h2>
  <p>
    <strong>1.</strong> Planet VG is committed to fostering a transparent and collaborative partnership, but we reserve
    the right to update or modify these Partner Terms when needed. If we make changes to the Partner Terms, we’ll notify
    you at least 30 days in advance via the email address linked to your partner account.
  </p>
  <p>
    <strong>2.</strong> Continued use of the Services or Partner App after the new terms take effect constitutes your
    acceptance of the updated Partner Terms. If you don’t agree with the changes, you may cancel your subscription in
    accordance with the cancellation policy outlined in these Partner Terms.
  </p>

  <h2>18. Ranking</h2>
  <p>
    <strong>1.</strong> Loyalty rewards are ranked in ascending order based on their “End Date.” We reserve the right to
    modify our ranking methodology in the future. Should any changes occur, you will be notified accordingly.
  </p>

  <h2>19. Governing law and dispute resolution</h2>
  <p>
    <strong>1.</strong> We believe in solving things amicably, but if it ever comes to a dispute (and mandatory law
    doesn’t require otherwise), any legal issues related to your use of Planet VG will be handled by the qualified Dutch
    court in our district. Let’s aim to keep it about collaboration, not courtrooms.
  </p>
  <p>
    <strong>2.</strong> Your use of Planet VG, these Partner Terms, and any agreements based on them are exclusively
    governed by Dutch law.
  </p>

  <h2>20. Some important final notes</h2>
  <p>
    <strong>1.</strong> Unless specifically stated otherwise, subscriptions don’t include (onboarding) support & maintenance. 
  </p>
  <p>
    <strong>2.</strong> We reserve the right to transfer our rights and duties to a third party. If you want to transfer any of your rights and duties, you need our written permission to do so (this provision also applies in the event of a takeover of your business activities).  
  </p>
  <p>
    <strong>3.</strong> If a provision of these Partner Terms is unlawful, invalid, or unenforceable for any other reason, this provision will be separated from the Partner Terms. The other provisions will remain in full force.
  </p>
  <p>
    <strong>4.</strong> The terms of the relevant subscription or offer shall prevail in case of conflict between those terms and the terms of these Partner terms. 
  </p>
  <p>
    <strong>5.</strong> We cannot be held to our offer if you should have understood that the offer, or any part thereof, contained an obvious mistake or error.
  </p>
  <p>
    <strong>6.</strong> If you accept these Partner Terms on behalf of a business, you represent and guarantee that you have the authority to bind that business to these Partner Terms
  </p>
  <p>
    <strong>7.</strong> Planet VG reserves the right to terminate or modify the Services at any time, without being liable for any damages.
  </p>

</div>